import { useState } from "react";

const CPassword = (props) => {
  const labelName = props.labelName;
  const name = props.name;
  const customStyle = props.customStyle1 === undefined ? {} : props.customStyle;
  const customClassLabel =
    props.customClassLabel === undefined ? "" : props.customClassLabel;
  const customClassInput =
    props.customClassInput === undefined ? "" : props.customClassInput;
  const customClassDiv =
    props.customClassDiv === undefined ? "" : props.customClassDiv;
  const required = props.required === true ? true : false;
  const placeholder = props.placeholder === undefined ? "" : props.placeholder;

  const [errorMsg, setErrorMsg] = useState("");
  const [isValid, setIsValid] = useState("");

  const checkRequired = (pass) => {
    if (pass.length > 0) {
      setErrorMsg("");
      setIsValid("");
      props.functionName(pass);
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Please fill this field");
    }
  };

  return (
    <>
      <div className={`${customClassDiv}`}>
        <label className={`form-label ${customClassLabel}`}>{labelName}</label>
        <input
          className={`form-control ${customClassInput} ${isValid}`}
          style={customStyle}
          name={name}
          type="password"
          placeholder={placeholder}
          required={required}
          onChange={(event) => {
            required === true
              ? checkRequired(event.target.value)
              : props.functionName(name, event.target.value);
          }}
        />
        <div className="invalid-feedback">{errorMsg}</div>
      </div>
    </>
  );
};

export default CPassword;
